// Ancien format "général par client" (__proj_<clientId>__) — conservé en lecture seule pour les
// données historiques non encore migrées (cf. migration_general_par_phase.sql). Plus jamais écrit.
export function projectBrickId(id: string): string {
  return `__proj_${id}__`;
}

export function isProjectEntry(id: unknown): id is string {
  return typeof id === 'string' && id.startsWith('__proj_');
}

export function projectIdFromEntry(id: string): string {
  return id.replace(/^__proj_/, '').replace(/__$/, '');
}

// Format actuel "général par phase" (__phase_<phaseId>__) : le temps sans brique précise est
// rattaché à UNE phase (ex. BEMOD/LAH/LM chez Lahaye ne se mélangent plus dans un même tiroir).
export function phaseBrickId(id: string): string {
  return `__phase_${id}__`;
}

export function isPhaseEntry(id: unknown): id is string {
  return typeof id === 'string' && id.startsWith('__phase_');
}

export function phaseIdFromEntry(id: string): string {
  return id.replace(/^__phase_/, '').replace(/__$/, '');
}
